module.exports = __webpack_public_path__ + "img/mysoundfiles.b1a1a7f3.png";